import lenis from './lenis';

const easeInOutExpo = ( t ) =>
    t === 0 ? 0
    : t === 1 ? 1
    : t < 0.5 ? Math.pow( 2, 20 * t - 10 ) / 2
    : ( 2 - Math.pow( 2, -20 * t + 10 ) ) / 2;

function getOffset() {
    const styles = getComputedStyle( document.documentElement );
    const isMobile = window.innerWidth < 768;
    const prop = isMobile ? '--header-height-mobile' : '--header-height';
    return -( parseInt( styles.getPropertyValue( prop ) ) || 0 ) - 20;
}

function scrollToTarget( target ) {
    const targetY = target.getBoundingClientRect().top + window.scrollY + getOffset();
    lenis.scrollTo( targetY, { duration: 1.4, easing: easeInOutExpo } );
}

function isSamePageAnchor( link ) {
    const href = link.getAttribute( 'href' );
    if ( ! href ) return null;

    if ( href.startsWith( '#' ) ) {
        return href.length > 1 ? href : null;
    }

    try {
        const url = new URL( href, window.location.href );
        if (
            url.origin === window.location.origin &&
            url.pathname === window.location.pathname &&
            url.hash
        ) {
            return url.hash;
        }
    } catch ( _ ) {}

    return null;
}

export function initAnchorScroll() {
    document.addEventListener( 'click', ( e ) => {
        const link = e.target.closest( 'a[href]' );
        if ( ! link ) return;

        const hash = isSamePageAnchor( link );
        if ( ! hash ) return;

        const target = document.querySelector( hash );
        if ( ! target ) return;

        e.preventDefault();
        scrollToTarget( target );
    } );

    if ( window.location.hash ) {
        const target = document.querySelector( window.location.hash );
        if ( target ) {
            history.scrollRestoration = 'manual';
            window.scrollTo( 0, 0 );
            setTimeout( () => scrollToTarget( target ), 200 );
        }
    }
}
